import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  /** Current UI locale */
  locale: string;
}

/** Reads the persisted UI locale, falling back to English. */
function readStoredLocale(): string {
  try {
    return localStorage.getItem('xtm-go-locale') || 'en';
  } catch {
    return 'en';
  }
}

const initialState: AuthState = {
  locale: readStoredLocale(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLocale(state, action: PayloadAction<string>) {
      state.locale = action.payload;
    },
  },
});

export const { setLocale } = authSlice.actions;
export default authSlice.reducer;
